export const iconFontAwesomeHouseholdFireBurner = (
	<i className="fa-solid fa-fire-burner"></i>
);
